import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./CircularStd-Book.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22./CircularStd-BookItalic.ttf%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22./CircularStd-Medium.ttf%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./CircularStd-MediumItalic.ttf%22,%22weight%22:%22500%22,%22style%22:%22italic%22},{%22path%22:%22./CircularStd-Bold.ttf%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./CircularStd-BoldItalic.ttf%22,%22weight%22:%22700%22,%22style%22:%22italic%22},{%22path%22:%22./CircularStd-Black.ttf%22,%22weight%22:%22900%22,%22style%22:%22normal%22},{%22path%22:%22./CircularStd-BlackItalic.ttf%22,%22weight%22:%22900%22,%22style%22:%22italic%22}]}],%22variableName%22:%22circularStd%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'circularStd', 'circularStd Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
